import React, { useState } from 'react'
import { SignedIn, SignedOut } from '@clerk/clerk-react'
import { AdminApiProvider } from './contexts/AdminApiContext'
import Header from './components/Header'
import Sidebar from './components/Sidebar'
import ContentArea from './components/ContentArea'
import SignInPage from './components/SignInPage'
import RoleProtection from './components/RoleProtection'
import './styles/App.css'

type ViewType = 'dashboard' | 'data-browser' | 'file-browser' | 'role-management'
type DataTable = 'users' | 'books' | 'chapters' | 'api_usage'
type FilePath = string

interface AppState {
  currentView: ViewType
  selectedTable?: DataTable
  selectedFilePath?: FilePath
}

const App: React.FC = () => {
  const [appState, setAppState] = useState<AppState>({
    currentView: 'dashboard'
  })

  const handleNavigationChange = (view: ViewType, table?: DataTable, filePath?: FilePath) => {
    setAppState({
      currentView: view,
      selectedTable: table,
      selectedFilePath: filePath
    })
  }

  return (
    <div className="app">
      <SignedOut>
        <SignInPage />
      </SignedOut>
      
      <SignedIn>
        <AdminApiProvider>
          <RoleProtection 
            requiredRole="admin"
            fallbackMessage="Admin access required to use this application"
          >
            <Header />
            <div className="app-body">
              <Sidebar 
                currentView={appState.currentView}
                selectedTable={appState.selectedTable}
                selectedFilePath={appState.selectedFilePath}
                onNavigationChange={handleNavigationChange}
              />
              <ContentArea 
                currentView={appState.currentView}
                selectedTable={appState.selectedTable}
                selectedFilePath={appState.selectedFilePath}
              />
            </div>
          </RoleProtection>
        </AdminApiProvider>
      </SignedIn>
    </div>
  )
}

export default App